import { render, staticRenderFns } from "./employee-registration-column.vue?vue&type=template&id=e761a8a0&scoped=true"
import script from "./employee-registration-column.vue?vue&type=script&lang=js"
export * from "./employee-registration-column.vue?vue&type=script&lang=js"
import style0 from "./employee-registration-column.vue?vue&type=style&index=0&id=e761a8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e761a8a0",
  null
  
)

export default component.exports